import React from "react";
import Modal from "antd/es/modal";
import {verifiedConfirmStatus} from "../../api/api";
import {displayGenericError} from "../../common/notifications";
import {Col, Row} from "antd";
import FieldValueVerticalCell from "../general/FieldValueVerticalCell";
import Divider from "antd/es/divider";

export default class CompliancePersonalInfoStatus extends React.Component {
    onOk = () => {
        verifiedConfirmStatus().then(res => {
            this.props.acceptConfirmPage();
        }).catch(error => {
            displayGenericError(error);
        });

    }

    componentDidMount() {

    }

    render() {
        let customer = this.props.customer;
        return (
            <Modal
                className="bp-modal"
                title="Personal Info confirmation"
                visible={this.props.visible}
                onOk={this.onOk}
                onCancel={this.props.onCancel}

                maskClosable={false}
                destroyOnClose={true}
                width="1024px"
                style={{top: "50px"}}
            >

                {customer.accountType === 'PERSONAL' && (
                    <div className="form--customer-acceptance">
                        <Row gutter={16}>
                            <Col md={12} sm={12}>
                                <FieldValueVerticalCell title="First Name"
                                                        value={customer.personalAccountDetails.firstName}/>
                            </Col>
                            <Col md={12} sm={12}>
                                <FieldValueVerticalCell title="Last Name"
                                                        value={customer.personalAccountDetails.lastName}/>
                            </Col>

                        </Row>
                        <Row gutter={16}>
                            <Col md={12} sm={12}>
                                <FieldValueVerticalCell title="Contact Number"
                                                        value={customer.personalAccountDetails.contactNumber}/>
                            </Col>
                            <Col md={12} sm={12}>
                                <FieldValueVerticalCell title="Source Of Wealth"
                                                        value={customer.personalAccountDetails.personalAccountDetails}/>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col md={12} sm={12}>
                                <FieldValueVerticalCell title="Occupation"
                                                        value={customer.personalAccountDetails.occupation}/>
                            </Col>
                            <Col md={12} sm={12}>
                                <FieldValueVerticalCell title="Industry"
                                                        value={customer.personalAccountDetails.industry}/>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col md={12} sm={12}>
                                <FieldValueVerticalCell title="Company"
                                                        value={customer.personalAccountDetails.company}/>
                            </Col>
                            <Col md={12} sm={12}>
                                <FieldValueVerticalCell title="Annual Income"
                                                        value={customer.personalAccountDetails.annualSalary}/>
                            </Col>
                        </Row>
                        <Divider/>
                        <div>Declaration</div>
                        <div style={{marginTop: '20px'}}>
                            I declare that the information provided in these forms are true and correct.I am aware that
                            I may be subject to
                            prosecution and criminal sanctions under written law if I am found to have made any false
                            statement which I know
                            to be false or which I do not believe to be true, or if I have intentionally suppressed and
                            material fact.
                        </div>
                    </div>

                )}
                {customer.accountType === 'CORPORATE' && (
                    <div className="form--customer-acceptance">
                        <Row gutter={16}>
                            <Col md={12} sm={12}>
                                <FieldValueVerticalCell title="Name of Business"
                                                        value={customer.corporateAccountDetails.nameOfBusiness}/>
                            </Col>
                            <Col md={12} sm={12}>
                                <FieldValueVerticalCell title="Business Registration Number"
                                                        value={customer.corporateAccountDetails.businessRegistrationNumber}/>
                            </Col>

                        </Row>
                        <Row gutter={16}>
                            <Col md={12} sm={12}>
                                <FieldValueVerticalCell title="Company’s date of incorporation"
                                                        value={customer.corporateAccountDetails.businessRegistrationNumber}/>
                            </Col>
                            <Col md={12} sm={12}>
                                <FieldValueVerticalCell title="Registered Address"
                                                        value={customer.corporateAccountDetails.registeredAddress}/>
                            </Col>
                        </Row>

                        <Divider/>
                        <div>Declaration</div>
                        <div style={{marginTop: '20px'}}>
                            I declare that the information provided in these forms are true and correct.I am aware that
                            I may be subject to
                            prosecution and criminal sanctions under written law if I am found to have made any false
                            statement which I know
                            to be false or which I do not believe to be true, or if I have intentionally suppressed and
                            material fact.
                        </div>
                    </div>
                )}


            </Modal>
        )
    }
}